import FundFamilySetupNoticeDocumentTemplateForm from "features/fund-family/setup/notices/FundFamilySetupNoticeTemplateForm";
import { FundFamilySubEventTypeEnum } from "gen/model/fundFamilySubEventTypeEnum";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const FundFamilySetupNoticesTabDistribution: React.FC = () => (
  <PageTabBody>
    <FundFamilySetupNoticeDocumentTemplateForm
      eventType={FundFamilySubEventTypeEnum.distribution}
    />
  </PageTabBody>
);
